import { render, staticRenderFns } from "./popularProducts.vue?vue&type=template&id=38a64f6b&scoped=true"
import script from "./popularProducts.vue?vue&type=script&lang=ts"
export * from "./popularProducts.vue?vue&type=script&lang=ts"
import style0 from "./popularProducts.vue?vue&type=style&index=0&id=38a64f6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../soccer/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a64f6b",
  null
  
)

export default component.exports